// import React from "react";
// import { motion } from "framer-motion";
// import {
//   FaEnvelope,
//   FaPhone,
//   FaMapMarkerAlt,
//   FaWhatsapp,
// } from "react-icons/fa";
// import Navbar from "../components/Navbar";

// const ContactPage = () => {
//   return (
//     <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#542757] via-[#7b1f5f] to-[#9b1f6c] text-white">
//       <Navbar />

//       <div className="flex-grow flex flex-col items-center justify-center px-4 py-8 mt-10">
//         <motion.div
//           className="w-full max-w-6xl bg-white/10 backdrop-blur-lg rounded-2xl shadow-lg p-8 md:p-12 border border-purple-500/30"
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <h1 className="text-4xl font-extrabold text-white text-center mb-8 drop-shadow-lg">
//             Contact Us
//           </h1>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
//             {/* Left Side: Contact Info */}
//             <div className="space-y-6">
//               <div>
//                 <h2 className="text-2xl font-bold text-white mb-4">
//                   Get in Touch
//                 </h2>
//                 <p className="text-purple-200 leading-relaxed mb-6">
//                   We’d love to hear from you! Whether you have questions about
//                   our products, need assistance, or want to discuss partnership
//                   opportunities, our team is ready to assist.
//                 </p>
//               </div>

//               {/* Email */}
//               <div className="flex items-start space-x-3">
//                 <FaEnvelope className="text-pink-400 text-xl mt-1" />
//                 <div>
//                   <p className="font-semibold text-white">Email</p>
//                   <a
//                     href="mailto:info@hlcpk.com"
//                     className="text-purple-100 hover:text-pink-300 transition"
//                   >
//                     info@hlcpk.com
//                   </a>
//                 </div>
//               </div>

//               {/* Call */}
//               <div className="flex items-start space-x-3">
//                 <FaPhone className="text-pink-400 text-xl mt-1" />
//                 <div>
//                   <p className="font-semibold text-white">Call Us</p>
//                   <a
//                     href="tel:+923702961896"
//                     className="text-purple-100 hover:text-pink-300 transition"
//                   >
//                     +92 370 2961896
//                   </a>
//                 </div>
//               </div>

//               {/* WhatsApp */}
//               <div className="flex items-start space-x-3">
//                 <FaWhatsapp className="text-green-400 text-xl mt-1" />
//                 <div>
//                   <p className="font-semibold text-white">WhatsApp</p>
//                   <div className="space-y-1">
//                     <a
//                       href="https://wa.me/923702961896"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="block text-purple-100 hover:text-green-300 transition"
//                     >
//                       +92 370 2961896
//                     </a>
//                     <a
//                       href="https://wa.me/923422151662"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="block text-purple-100 hover:text-green-300 transition"
//                     >
//                       +92 342 2151662
//                     </a>
//                   </div>
//                 </div>
//               </div>

//               {/* Address */}
//               <div className="flex items-start space-x-3">
//                 <FaMapMarkerAlt className="text-pink-400 text-xl mt-1" />
//                 <div>
//                   <p className="font-semibold text-white mb-2">Addresses</p>

//                   <div className="space-y-4 text-purple-100 leading-relaxed">
//                     <div>
//                       <p className="font-semibold text-white">Factory</p>
//                       <p>Plot A-13, Site Area, Sukkur</p>
//                       <a
//                         href="tel:+923702961896"
//                         className="hover:text-pink-300 transition"
//                       >
//                         +92 370 2961896
//                       </a>
//                     </div>

//                     <div>
//                       <p className="font-semibold text-white">Head Office</p>
//                       <p>
//                         K-7/17, Main Chaudhry Khaliq uz Zaman Road, Gizri,
//                         Karachi
//                       </p>
//                       <a
//                         href="tel:02135866046"
//                         className="hover:text-pink-300 transition"
//                       >
//                         021 35866046
//                       </a>
//                     </div>

//                     <div>
//                       <p className="font-semibold text-white">
//                         Factory Outlet
//                       </p>
//                       <p>
//                         Shop # M-53, Mezzanine Floor, Nawab Estate, Densohall,
//                         Karachi
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* WhatsApp CTA Button */}
//               <div className="pt-4">
//                 <a
//                   href="https://wa.me/923702961896"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-3 rounded-xl shadow-lg transition duration-300"
//                 >
//                   <FaWhatsapp className="text-xl" />
//                   Chat on WhatsApp
//                 </a>
//               </div>
//             </div>

//             {/* Right Side: Google Map */}
//             <motion.div
//               className="w-full h-72 md:h-[500px] rounded-xl overflow-hidden shadow-md border border-purple-500/30"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ delay: 0.3, duration: 0.6 }}
//             >
//               <iframe
//                 title="HLC Pakistan Location"
//                 width="100%"
//                 height="100%"
//                 loading="lazy"
//                 allowFullScreen
//                 referrerPolicy="no-referrer-when-downgrade"
//                 className="rounded-xl"
//                 src="https://www.google.com/maps?q=Karachi,Pakistan&output=embed"
//               ></iframe>
//             </motion.div>
//           </div>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default ContactPage;

import React from "react";
import { motion } from "framer-motion";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";
import Navbar from "../components/Navbar";
import HlcFooter from "../components/HlcFooter";

const fadeUp = {
  hidden: { opacity: 0, y: 25 },
  show: { opacity: 1, y: 0 },
};

const ContactPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#542757] via-[#7b1f5f] to-[#9b1f6c] text-white overflow-x-hidden">
      <Navbar />

      <div className="flex-grow flex items-center justify-center px-4 py-6 md:py-10 mt-10">
        <motion.div
          className="w-full max-w-6xl bg-white/10 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-5 md:p-10"
          initial="hidden"
          animate="show"
          variants={{
            hidden: {},
            show: {
              transition: {
                staggerChildren: 0.15,
              },
            },
          }}
        >
          {/* Title */}
          <motion.h1
            variants={fadeUp}
            className="text-3xl md:text-4xl font-extrabold text-center mb-6 md:mb-10"
          >
            Contact Us
          </motion.h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
            {/* LEFT SIDE */}
            <div className="space-y-6">
              {/* Intro */}
              <motion.div variants={fadeUp}>
                <h2 className="text-xl md:text-2xl font-bold mb-3">
                  Get in Touch
                </h2>
                <p className="text-purple-200 leading-relaxed">
                  We’d love to hear from you! Whether you have questions about
                  our products, need assistance, or want to discuss partnership
                  opportunities, our team is ready to assist.
                </p>
              </motion.div>

              {/* Email */}
              <motion.div
                variants={fadeUp}
                whileHover={{ scale: 1.02 }}
                className="flex items-start gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition"
              >
                <FaEnvelope className="text-pink-400 text-xl mt-1" />
                <div>
                  <p className="font-semibold">Email</p>
                  <a
                    href="mailto:info@hlcpk.com"
                    className="text-purple-200 hover:text-pink-300"
                  >
                    info@hlcpk.com
                  </a>
                </div>
              </motion.div>

              {/* Phone */}
              <motion.div
                variants={fadeUp}
                whileHover={{ scale: 1.02 }}
                className="flex items-start gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition"
              >
                <FaPhone className="text-pink-400 text-xl mt-1" />
                <div>
                  <p className="font-semibold">Call Us</p>
                  <a
                    href="tel:+923702961896"
                    className="text-purple-200 hover:text-pink-300"
                  >
                    +92 370 2961896
                  </a>
                </div>
              </motion.div>

              {/* WhatsApp */}
              <motion.div
                variants={fadeUp}
                whileHover={{ scale: 1.02 }}
                className="flex items-start gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition"
              >
                <FaWhatsapp className="text-green-400 text-xl mt-1" />
                <div>
                  <p className="font-semibold">WhatsApp</p>
                  <div className="space-y-1">
                    <a
                      href="https://wa.me/923702961896"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-purple-200 hover:text-green-300"
                    >
                      +92 370 2961896
                    </a>
                    <a
                      href="https://wa.me/923422151662"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-purple-200 hover:text-green-300"
                    >
                      +92 342 2151662
                    </a>
                  </div>
                </div>
              </motion.div>

              {/* Address */}
              <motion.div
                variants={fadeUp}
                whileHover={{ scale: 1.02 }}
                className="flex items-start gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition"
              >
                <FaMapMarkerAlt className="text-pink-400 text-xl mt-1" />
                <div>
                  <p className="font-semibold mb-2">Addresses</p>

                  <div className="space-y-3 text-purple-200 text-sm">
                    <div>
                      <p className="font-semibold text-white">Factory</p>
                      <p>Plot A-13, Site Area, Sukkur</p>
                      <a href="tel:+923702961896">
                        +92 370 2961896
                      </a>
                    </div>

                    <div>
                      <p className="font-semibold text-white">Head Office</p>
                      <p>
                        K-7/17, Main Chaudhry Khaliq uz Zaman Road, Gizri,
                        Karachi
                      </p>
                      <a href="tel:02135866046">
                        021 35866046
                      </a>
                    </div>

                    <div>
                      <p className="font-semibold text-white">
                        Factory Outlet
                      </p>
                      <p>
                        Shop # M-53, Mezzanine Floor, Nawab Estate, Densohall,
                        Karachi
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* CTA */}
              <motion.div
                variants={fadeUp}
                animate={{ y: [0, -5, 0] }}
                transition={{ repeat: Infinity, duration: 2 }}
                className="pt-2"
              >
                <a
                  href="https://wa.me/923702961896"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-3 rounded-xl shadow-lg transition"
                >
                  <FaWhatsapp />
                  Chat on WhatsApp
                </a>
              </motion.div>
            </div>

            {/* RIGHT SIDE MAP */}
            <motion.div
              variants={fadeUp}
              className="w-full h-64 md:h-[450px] rounded-2xl overflow-hidden border border-white/20 shadow-lg"
            >
              <iframe
                title="HLC Pakistan Location"
                width="100%"
                height="100%"
                loading="lazy"
                className="rounded-2xl"
                src="https://www.google.com/maps?q=Karachi,Pakistan&output=embed"
              ></iframe>
            </motion.div>
          </div>
        </motion.div>
      </div>
      <HlcFooter />
    </div>
  );
};

export default ContactPage;